import { motion } from "framer-motion";
import { Check } from "lucide-react";

const advantages = [
  {
    number: "01",
    title: "Прозрачные цены",
    description: "Фиксированная стоимость услуг без скрытых платежей. Вы знаете итоговую сумму до начала работы.",
  },
  {
    number: "02",
    title: "Полный цикл",
    description: "От подбора автомобиля до регистрации в ГАИ — все этапы под ключ без вашего участия.",
  },
  {
    number: "03",
    title: "Проверенные авто",
    description: "Тщательная проверка истории, пробега и технического состояния каждого автомобиля.",
  },
  {
    number: "04",
    title: "Официальное оформление",
    description: "Все документы, сертификаты и таможенное оформление строго по законодательству РБ.",
  },
  {
    number: "05",
    title: "Быстрые сроки",
    description: "Доставка из Китая — от 30 дней, из Кореи — от 25 дней, из США — от 45 дней.",
  },
  {
    number: "06",
    title: "Гарантия результата",
    description: "Несём полную ответственность за сохранность авто и соблюдение сроков доставки.",
  },
];

export default function AdvantagesSection() {
  return (
    <section 
      id="advantages" 
      className="py-24 bg-[#0A0A0A]"
      data-testid="advantages-section"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-20 max-w-2xl"
        >
          <p className="text-white/40 text-xs uppercase tracking-[0.3em] mb-4">
            Почему мы
          </p>
          <h2 className="text-4xl md:text-6xl text-white font-normal mb-6">
            Преимущества
          </h2>
          <p className="text-white/50 text-lg font-light">
            Работаем на результат и репутацию. Каждый клиент получает персональный подход.
          </p>
        </motion.div>

        {/* Advantages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          {advantages.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="group"
              data-testid={`advantage-${index}`}
            >
              <div className="flex items-start gap-6">
                <span className="text-white/20 text-4xl font-light">
                  {item.number}
                </span>
                <div>
                  <h3 className="text-white text-lg font-normal mb-3 font-sans">
                    {item.title}
                  </h3>
                  <p className="text-white/40 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
